import CrudTab from 'react/containers/pages/CrudTab';

class RouteProgress extends CrudTab {

  static tabName = 'Greenmile.RouteProgress.screenName'

  componentDidMount() {
    App.Objects.RouteProgress = new App.Routers.RouteProgress();
    App.Objects.RouteProgress.show();
  }

  componentDidUpdate() {}

}

export default RouteProgress;
